var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
var SeguimientoCertificadosComponent = /** @class */ (function () {
    function SeguimientoCertificadosComponent(_snackBar, dialog, store, _user, spinner, _cd, _router, claveUnicaService) {
        this._snackBar = _snackBar;
        this.dialog = dialog;
        this.store = store;
        this._user = _user;
        this.spinner = spinner;
        this._cd = _cd;
        this._router = _router;
        this.claveUnicaService = claveUnicaService;
        this.buscando = false;
        this.numSol = new FormControl('', [Validators.required]);
        this.fecha_ingreso = new FormControl('', [Validators.required]);
        this.identity = this._user.getIdentity();
        if (sessionStorage.getItem('identity-domCloud')) {
            this.searchUser();
        } /* else {
          this._router.navigate(['/inicio'])
          swal({
            type: 'warning',
            text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          })
        } */
    }
    SeguimientoCertificadosComponent.prototype.ngOnInit = function () {
    };
    SeguimientoCertificadosComponent.prototype.get_certificado = function () {
        var _this = this;
        this.spinner.show();
        this._user.get_certificado(this.numSol.value).subscribe(function (response) {
            console.log(response);
            var fechax, fechaCertificado;
            if (response.certificado.length > 0) {
                _this.spinner.hide();
                _this.certificado_info = response.certificado;
                console.log(_this.certificado_info);
                _this.buscando = true;
                var arreglox = [];
                _this.certificado_info.forEach(function (element, index) {
                    //console.log(element.fieldData['Propiedad 2::Pro_Propie_ROL']);
                    if (index == 0) {
                        _this.arreglo = [{
                                rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
                                data: []
                            }];
                        arreglox.push(element.fieldData['Propiedad 2::Pro_Propie_ROL']);
                        _this.arreglo[index]['data'].push({
                            nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
                            direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
                            estado: element.fieldData['TRACER_Estado_Descripcion']
                        });
                    }
                    else {
                        var rolactual = element.fieldData['Propiedad 2::Pro_Propie_ROL'];
                        if (arreglox.indexOf(rolactual) !== -1) {
                            /* OK, value exists! */
                            var indexActual = arreglox.indexOf(rolactual);
                            //console.log(indexActual)
                            //console.log("ya existe el rol dentro")
                            _this.arreglo[indexActual]['data'].push({
                                nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
                                direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
                                estado: element.fieldData['TRACER_Estado_Descripcion']
                            });
                        }
                        else {
                            var arregl2;
                            arregl2 = [{
                                    rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
                                    data: []
                                }];
                            arregl2[0]['data'].push({
                                nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
                                direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
                                estado: element.fieldData['TRACER_Estado_Descripcion']
                            });
                            Array.prototype.push.apply(_this.arreglo, arregl2);
                        }
                    }
                });
                //console.log(this.arreglo)
                fechax = _this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora;
                fechaCertificado = moment(fechax).format("DD/MM/YYYY");
                _this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora = fechaCertificado;
            }
            else {
                _this.spinner.hide();
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "No se encontraron registros de certificados con ese numero de solicitud",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
        }, function (error) {
            console.log(error);
        });
    };
    SeguimientoCertificadosComponent.prototype.volver = function () {
        this.buscando = false;
        this.numSol.setValue("");
        this.fecha_ingreso.setValue("");
    };
    SeguimientoCertificadosComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    SeguimientoCertificadosComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    SeguimientoCertificadosComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    SeguimientoCertificadosComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._user.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._user.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return SeguimientoCertificadosComponent;
}());
export { SeguimientoCertificadosComponent };
